import React from 'react';
import { Link } from 'react-router-dom';
import { FaTwitter, FaGithub, FaLinkedin, FaFacebook, FaInstagram } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-catalina-blue text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/logo-white.svg" 
                alt="Trolift Logo" 
                className=" w-20 mr-4"
              />
            </div>
            <p className="text-gray-300 mb-4">
              Delivering excellence in every project. Your trusted partner for innovative solutions.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/people/Trolift-Solution/61581150721092/" className="text-gray-300 hover:text-tango transition duration-300">
                <FaFacebook className="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/troliftsolutions/" className="text-gray-300 hover:text-tango transition duration-300">
                <FaInstagram className="w-6 h-6" />
              </a>
              <a href="https://www.linkedin.com/company/trolift-solutions/" className="text-gray-300 hover:text-tango transition duration-300">
                <FaLinkedin className="w-6 h-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-tango transition duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-tango transition duration-300">
                  About
                </Link>
              </li>
              <li>
                <Link to="/solutions-we-provide" className="text-gray-300 hover:text-tango transition duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-300 hover:text-tango transition duration-300">
                  Products
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Email:<a href="mailto:info@trolift.com" className="hover:text-tango transition duration-300"> info@trolift.com </a></li>
              <li>Phone: <a href="tel:+918239992123" className="hover:text-tango transition duration-300">+91 8239992123</a> / <a href="tel:+918387870788" className="hover:text-tango transition duration-300">+91 8387870788 </a></li>
              <li>Address: SR-5, Ramchandrpura Industrial Area, near Skoda Service Center, Tuwariyan Ki Dhani, Jaipur, Vidhani, Rajasthan 302022</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-san-marino mt-8 pt-8 text-center text-gray-300">
          <p>&copy; {new Date().getFullYear()} Trolift. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;